// Pure helpers shared by the StudyPlanAdd and StudyPlanEdit cards.
//
// These were duplicated near-identically across both files:
// - getStudyPlan shapes the request body the API expects. The Add
//   variant doesn't carry id/version (they're undefined until the API
//   returns); the Edit variant relies on them being there. We keep one
//   helper and let undefined fields fall through harmlessly.
// - cloneLessons deep-clones the lesson array so editing UIs can
//   diff against the original.
// - lessonInputsKey serialises the parts of the plan that drive the
//   lesson-generation prompt. The Add card uses this to decide
//   whether the cached generated lessons are still valid for the
//   current inputs.

export function buildStudyPlanPayload(plan, lessons) {
  return {
    id: plan.id,
    version: plan.version,
    subject: plan.subject,
    goal: plan.goal,
    previous_knowledge: plan.previous_knowledge,
    needs: plan.needs,
    emoji: plan.emoji,
    num_lessons: parseInt(plan.num_lessons),
    lessons,
  };
}

export function cloneLessons(lessons) {
  return JSON.parse(JSON.stringify(lessons || []));
}

export function lessonInputsKey(plan) {
  return JSON.stringify({
    subject: plan.subject,
    goal: plan.goal,
    previous_knowledge: plan.previous_knowledge,
    needs: plan.needs,
  });
}
